
import Vue, { PropType } from 'vue'
import { MenuLink } from '@/model/MenuLink'
import AccountButtons from '@/components/user/AccountButtons.vue'

export default Vue.extend({
  name: 'BottomNavigation',
  components: {
    AccountButtons,
  },
  computed: {
    firstMenu: function (): MenuLink[] {
      return this.elements.slice(0, 3)
    },
    secondMenu: function (): MenuLink[] {
      return this.elements.slice(3, 6)
    },
  },
  props: {
    value: {},
    elements: {
      type: Array as PropType<MenuLink[]>,
    },
  },
  data: () => ({
    fabCloseHidden: true,
  }),
  methods: {
    onScroll: function (event: Event) {
      if ((event.target as Element).scrollTop > 50) {
        this.fabCloseHidden = false
        return
      }

      this.fabCloseHidden = true
    },
  },
})
